import React__default, { createElement, createRef } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _path;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M0 277.333h384V320H0zM0 170.667h384v42.667H0zM0 64h384v42.667H0z"
  })));
}

var styles = {"navbar_wrapper":"_3drDv","logo_wrapper":"_36iSm","nav_elements":"_29JqD","mob_nav":"_3xYLB","sidebar_wrapper":"_4sag1","left":"_2lGdA","left_logo":"_3vScg","left_nav":"_3Moxr","btn_left":"_1tOke"};

var Navbar = function Navbar(_ref) {
  var logo = _ref.logo,
      items = _ref.items,
      style = _ref.style,
      _float = _ref["float"];

  var styled = _extends({
    barStyles: {
      background: '#0984e3'
    },
    linkStyles: {
      color: 'white'
    },
    logoStyles: {
      fontSize: '20px',
      color: 'white'
    },
    sidebarStyles: {
      background: 'grey',
      buttonColor: 'white'
    }
  }, style);

  var cross = createRef();

  var onOpen = function onOpen() {
    cross.current.style.width = '200px';
  };

  var onClose = function onClose() {
    cross.current.style.width = '0';
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.navbar_wrapper,
    style: _extends({}, styled.barStyles, {
      position: _float ? 'fixed' : null
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.logo_wrapper
  }, /*#__PURE__*/React__default.createElement("a", {
    style: _extends({}, styled.logoStyles),
    href: logo.link
  }, logo.img ? /*#__PURE__*/React__default.createElement("img", {
    src: logo.img,
    alt: "logo"
  }) : logo.text)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.nav_elements
  }, items.map(function (_ref2, indx) {
    var text = _ref2.text,
        link = _ref2.link;
    return /*#__PURE__*/React__default.createElement("a", {
      href: link,
      key: indx,
      style: _extends({}, styled.linkStyles)
    }, text);
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.mob_nav
  }, /*#__PURE__*/React__default.createElement(SvgMenu, {
    style: {
      fill: styled.sidebarStyles.buttonColor
    },
    onClick: onOpen
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.sidebar_wrapper,
    ref: cross,
    style: _extends({}, styled.sidebarStyles)
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: onClose,
    style: {
      color: styled.sidebarStyles.buttonColor
    }
  }, "\u2716"), items.map(function (_ref3, indx) {
    var text = _ref3.text,
        link = _ref3.link;
    return /*#__PURE__*/React__default.createElement("a", {
      href: link,
      key: indx,
      style: _extends({}, styled.linkStyles, {
        background: styled.sidebarStyles.background
      })
    }, text);
  }))));
};
var NavbarLeft = function NavbarLeft(_ref4) {
  var logo = _ref4.logo,
      items = _ref4.items,
      style = _ref4.style,
      _float2 = _ref4["float"];

  var styled = _extends({
    barStyles: {
      background: '#0984e3'
    },
    linkStyles: {
      color: 'white'
    },
    logoStyles: {
      fontSize: '20px',
      color: 'white'
    },
    sidebarStyles: {
      background: 'grey',
      buttonColor: 'white'
    }
  }, style);

  var cross = createRef();

  var onOpen = function onOpen() {
    cross.current.style.width = '200px';
  };

  var onClose = function onClose() {
    cross.current.style.width = '0';
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.navbar_wrapper + " " + styles.left,
    style: _extends({}, styled.barStyles, {
      position: _float2 ? 'fixed' : null
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.logo_wrapper + " " + styles.left_logo
  }, /*#__PURE__*/React__default.createElement("a", {
    style: _extends({}, styled.logoStyles),
    href: logo.link
  }, logo.img ? /*#__PURE__*/React__default.createElement("img", {
    src: logo.img,
    alt: "logo"
  }) : logo.text)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.nav_elements
  }, items.map(function (_ref5, indx) {
    var text = _ref5.text,
        link = _ref5.link;
    return /*#__PURE__*/React__default.createElement("a", {
      href: link,
      key: indx,
      style: _extends({}, styled.linkStyles)
    }, text);
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.mob_nav
  }, /*#__PURE__*/React__default.createElement(SvgMenu, {
    style: {
      fill: styled.sidebarStyles.buttonColor
    },
    onClick: onOpen
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.sidebar_wrapper + " " + styles.left_nav,
    ref: cross,
    style: _extends({}, styled.sidebarStyles)
  }, /*#__PURE__*/React__default.createElement("button", {
    className: styles.btn_left,
    onClick: onClose,
    style: {
      color: styled.sidebarStyles.buttonColor
    }
  }, "\u2716"), items.map(function (_ref6, indx) {
    var text = _ref6.text,
        link = _ref6.link;
    return /*#__PURE__*/React__default.createElement("a", {
      href: link,
      key: indx,
      onClick: () => {console.log("hola2")},
      style: _extends({}, styled.linkStyles, {
        background: styled.sidebarStyles.background
      })
    }, text);
  }))));
};

export { Navbar, NavbarLeft };
//# sourceMappingURL=index.modern.js.map
